import { Card, CardContent, CardHeader, Table, TableBody, TableCell, TableContainer, TableRow } from "@mui/material";
import { useMemo } from "react";
import { SiteType } from "shared/types";
import { CONFIGS, defaultChronicleFilenameMapping } from "../constants/tableConfig";
import { IecConfigInfo, RampTestKey } from "../types";
import { getJBoxTypeFromRackCount } from "../utils";
import ChronicleFilenameRow from "./ChronicleFilenameRow";
import PlanningSection from "./PlanningSection";

type TableFormContainerProps = {
  rampTestKey: RampTestKey;
  formTitle: string;
  iecConfigInfo: IecConfigInfo;
  sites: SiteType[];
};

const TableFormContainer = ({ rampTestKey, formTitle, iecConfigInfo, sites }: TableFormContainerProps) => {
  const { iecConfigChoices, iecConfigsLoading, iecConfigsError } = iecConfigInfo;

  const chronicleFilenameDefaultValue = useMemo(() => {
    if (iecConfigsLoading || iecConfigsError || !iecConfigChoices || !iecConfigChoices.length) return undefined;
    const defaultValue = defaultChronicleFilenameMapping[rampTestKey];
    return iecConfigChoices.some((choice) => choice.id === defaultValue) ? defaultValue : undefined;
  }, [iecConfigsLoading, iecConfigsError, iecConfigChoices, rampTestKey]);

  const existingJboxTypes = useMemo(
    () => [...new Set(sites.map((site) => getJBoxTypeFromRackCount(site.rack_count)))],
    [sites],
  );

  return (
    <Card sx={{ width: "100%", mb: 4, bgcolor: "#f0f0f0" }}>
      <CardHeader title={formTitle} sx={{ mt: 2 }} />
      <CardContent>
        <TableContainer sx={{ "& .MuiTableCell-root": { border: "none" } }}>
          <Table>
            <TableBody sx={{ borderTop: "1px solid black" }}>
              {CONFIGS.map((config, idx) => (
                <PlanningSection
                  key={config.groupKey}
                  config={config}
                  rampTestKey={rampTestKey}
                  existingJboxTypes={existingJboxTypes}
                  idx={idx}
                />
              ))}

              <TableRow sx={{ borderTop: "1px solid black" }}>
                <TableCell colSpan={4} />
              </TableRow>

              <ChronicleFilenameRow
                rampTestKey={rampTestKey}
                iecConfigInfo={iecConfigInfo}
                chronicleFilenameDefaultValue={chronicleFilenameDefaultValue}
              />
            </TableBody>
          </Table>
        </TableContainer>
      </CardContent>
    </Card>
  );
};

export default TableFormContainer;
